import { useCurrentUser } from '../routing/users/useCurrentUser';
import { isAdmin, isBlogger, isSuperAdmin } from './accessService';

export const useIsContentPromotionEnabled = () => {
    const currentUser = useCurrentUser();
    const role = currentUser?.profile?.role;

    return role && (isAdmin(role) || isSuperAdmin(role)) && !isBlogger(role);
};
